
import { FC, useContext, useEffect, useState } from "react";
import { GroupBase, MultiValue, OptionsOrGroups, SingleValue } from "react-select";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { format, parse, } from "date-fns";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { useDebouncedCallback } from "use-debounce";


import { reportFilterProps, ReportFilterState } from "./types";
import { DRUG_NAME } from "src/components/ActionDashBoardFilter/types";
import { AuthContext } from "src/context/authContext";
import { isZilrettaUser } from "src/helpers";
import { limitShift, offset, shift } from "@floating-ui/react";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";




const ReportsFilter: FC<reportFilterProps> = ({ updateQueryParams, defaultQueryParams }): JSX.Element => {

    const [filteredDocListing, updatedFilteredDocListing] = useState<{ id: number; name: string; }[]>([])
    const [filteredPracticeListing, updatedFilteredPracticeListing] = useState<{ id: number; name: string; }[]>([])
    const [filteredInsuranceListing, updatedFilteredInsuranceListing] = useState<{ id: number; name: string; }[]>([])

    const { control, handleSubmit, reset, getValues, watch, setValue } = useForm<ReportFilterState>({
        mode: 'all',
        defaultValues: defaultQueryParams,
    });
    const { userData } = useContext(AuthContext);
    setValue("drug_name", getValues('drug_name') === "All Product" || getValues('drug_name') === "" ? DRUG_NAME[0].value : getValues('drug_name'))
    const start_date = watch("start_date");
    const end_date = watch("end_date");
    const practice_Id = watch("practice_id");

    const { error: insuranceListingApiError, data: insuranceListingApiResponse, mutate: getinsuranceListing } =
        useFetch<{ id: number; name: string; }[]>(APIEndpoints.FETCH_INSURANCE);

    /** @first */
    useEffect(() => {
        if (insuranceListingApiResponse || insuranceListingApiError) {
          if (insuranceListingApiResponse) {
            updatedFilteredInsuranceListing((oldVal) => {
              const merged = [...oldVal, ...insuranceListingApiResponse];
              const uniqueSorted = Array.from(new Map(merged.map(i => [i.id, i])).values())
                .sort((a, b) => (a.name > b.name ? 1 : -1));
              return uniqueSorted;
            });
          }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [insuranceListingApiResponse, insuranceListingApiError]);     


    const { error: doctorListingApiError, data: doctorListingApiResponse, mutate: getdoctorListing } =
        useFetch<{ id: number; name: string; }[]>(APIEndpoints.GET_MANUFACTURER_FILTER_DOCTOR);



    /** @second */
    useEffect(() => {
        if (doctorListingApiResponse && !doctorListingApiError) {
          updatedFilteredDocListing((prev) => {
            const combined = [...prev, ...doctorListingApiResponse];
            // Deduplicate by ID
            const unique = Array.from(new Map(combined.map((doc) => [doc.id, doc])).values());
            // Sort alphabetically
            return unique.sort((a, b) => a.name.localeCompare(b.name));
          });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [doctorListingApiResponse]);
      



    const { error: practiceListingApiError, data: practiceListingApiResponse, mutate: getpracticeListing } =
        useFetch<{ id: number; name: string; }[]>(APIEndpoints.GET_MANUFACTURER_FILTER_PRACTICE);



    /** @third */
    useEffect(() => {
        if (practiceListingApiResponse || practiceListingApiError) {
            if (practiceListingApiResponse) {
                updatedFilteredPracticeListing((oldVal) => {
                    const newPatients = [...oldVal, ...practiceListingApiResponse]
                        .sort((patientA, patientB) => (patientA.name > patientB.name) ? 1 : -1)
                    return [...new Map(newPatients.map(patient => [patient["id"], patient])).values()];
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [practiceListingApiResponse, practiceListingApiError]);




    const searchForStats = (values: ReportFilterState) => {
        const updatedValues = {
            ...defaultQueryParams,
            ...values,
            practice_id:
                values.practice_id ?
                    (typeof values.practice_id === "string" ? values.practice_id : (values.practice_id as unknown as { value: string; label: string; }).value)
                    : "",
            drug_name:
                values.drug_name
                    ? (typeof values.drug_name === "string"
                        ? values.drug_name === "All Product"
                            ? ""
                            : values.drug_name
                        : (values.drug_name as { value: string; label: string }).value === "All Product"
                            ? ""
                            : (values.drug_name as { value: string; label: string }).value)
                    : "",
                    global_doctor_ids: Array.isArray(values.global_doctor_ids)
                    ? values.global_doctor_ids.join(",")
                    : typeof (values.global_doctor_ids as any)?.value !== "undefined"
                    ? Array.isArray((values.global_doctor_ids as any).value)
                      ? (values.global_doctor_ids as any).value.join(",")
                      : String((values.global_doctor_ids as any).value)
                    : "",
            insurance_name:
                values.insurance_name ?
                    (typeof values.insurance_name === "string" ? values.insurance_name : (values.insurance_name as unknown as { value: string; label: string; }).label)
                    : "",
            // insurance_name:
            //     values.insurance_name ?
            //         (typeof values.insurance_name === "string" ? values.insurance_name : (values.insurance_name as unknown as { value: string; label: string; }).label)
            //         : "",
        };

        updateQueryParams(updatedValues, false);
    };






    //:- Filtering practice from api recieved listing
    const filterPractice = (search: string) => {
        if (search.length >= 2) {
            getpracticeListing({}, {}, { query: search.trim() })
            // updatedFilteredPracticeListing(
            //     practiceDropdown.filter((prac) => prac.name.toLowerCase().includes(search.toLowerCase()))
            // )
        }
    };
    const debouncedFilterPractice = useDebouncedCallback(filterPractice, 500);

    //:- Filtereing doctor from api recieved listing
    const filterDoctor = (search: string) => {
        if (search.length >= 2) {
            !practice_Id && getdoctorListing({}, {}, { query: search.trim() })
        }

    };
    const debouncedFilterDoctor = useDebouncedCallback(filterDoctor, 500);

    const filterInsurance = (search: string) => {
        if (search.length >= 2) {
            !practice_Id && getinsuranceListing({}, {}, { insurance_name: search.trim() })
        }

    };
    const debouncedFilterInsurance = useDebouncedCallback(filterInsurance, 500);



    const handlePracticeChange = (practiceId: string) => {
        practiceId && getdoctorListing({}, {},
            { practice_id: practiceId }
        )
    };
    const clearFormData = () => {
        const values = {
            ...defaultQueryParams,
            start_date: format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
            end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
            practice_id: "",
            global_doctor_id: "",
            //case_id: "",
            //global_patient_id: "",
            //patient_id: "",
            // doctor_name: "",
            drug_name: "",
            insurance_name: ""
            //global_patient_external_id:''


        };

        reset(values);
        updatedFilteredDocListing([]);
        console.log("FILTER LISTINGG", filteredDocListing)
        updatedFilteredPracticeListing([]);
        updateQueryParams(getValues(), true);
    };

    return (
        <form className="filters row g-2" onSubmit={handleSubmit(searchForStats)}>
            <div className="col product-field mb-2">
                <Controller
                    name="drug_name"
                    control={control}
                    defaultValue={DRUG_NAME[0]?.value} // pehla option default
                    render={({ field }) => {
                        //console.log("drug_name field.value 👉", field.value);
                        return (
                            <Select
                                id="drug_name"
                                placeholder="Select Product"
                                isDisabled={isZilrettaUser(userData)}
                                options={
                                    DRUG_NAME.length > 0
                                        ? DRUG_NAME.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))
                                        : []
                                }
                                value={
                                    field.value
                                        ? DRUG_NAME.find((item) => item.value === field.value)
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    field.onChange(selectedOption ? selectedOption.value : "")
                                }
                                onBlur={field.onBlur}
                            />
                        );
                    }}
                />


            </div>
            <div className="col date-field mb-2">
                <Controller
                    name="start_date"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                            onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                            customInput={
                                <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                                    <input {...inputProps} />}
                                </ReactInputMask>
                            }
                            className="form-control" wrapperClassName="w-100"
                            placeholderText="mm/dd/yyyy"
                            dateFormat="MM/dd/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            maxDate={end_date ? new Date(end_date) : undefined}
                            portalId="root"
                            popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
                        />
                    )}
                />
            </div>
            <div className="col date-field mb-2">
                <Controller
                    name="end_date"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                            onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                            customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) => <input {...inputProps} />}</ReactInputMask>}
                            className="form-control" wrapperClassName="w-100"
                            placeholderText="mm/dd/yyyy"
                            dateFormat="MM/dd/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            minDate={start_date ? new Date(start_date) : undefined}
                            portalId="root"
                            popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
                        />
                    )}
                />
            </div>
            <div className="col mb-2">
                <Controller
                    name="practice_id"
                    control={control}
                    render={({ field }) => {
                        return (
                            <Select
                                options={(filteredPracticeListing.length > 0 ?
                                    filteredPracticeListing.map((item) => ({
                                        value: item.id.toString(),
                                        label: item.name
                                    }))
                                    : []
                                ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                                id="practice_id"
                                placeholder="Select Practice"
                                isSearchable={true}
                                isClearable={true}
                                {...field}
                                value={
                                    (() => {
                                        if (practiceListingApiResponse) {
                                            if (field.value === "") return null;
                                            const options = filteredPracticeListing.map((item) => ({
                                                value: item.id.toString(),
                                                label: item.name,
                                            }));
                                            const selected = options.find((opt) => opt.value === field.value) as unknown as MultiValue<unknown>;
                                            if (selected) {
                                                return selected;
                                            }
                                        }
                                    })()
                                }
                                onChange={(selected) => {
                                    const value = (selected as { value: string; label: string } | null)?.value || "";
                                    // update RHF value
                                    field.onChange(value);
                                    // 👇 apna function call karo
                                    handlePracticeChange(value);
                                }}
                                noOptionsMessage={() => "Please enter 2 or more characters to search..."}
                                onInputChange={debouncedFilterPractice}
                                onMenuClose={() => updatedFilteredPracticeListing([])}

                            />
                        )
                    }}
                />
            </div>
            <div className="col mb-2">
                <Controller
                    name="global_doctor_ids"
                    control={control}
                    defaultValue={''}
                    render={({ field }) => (
                        <Select
                            options={(filteredDocListing.length > 0 ?
                                filteredDocListing.map((item) => ({ value: item.id, label: item.name }))
                                : []
                            ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                            id="global_doctor_ids"
                            placeholder="Select Doctor"
                            isSearchable={true}
                            isClearable={true}
                            {...field}
                            // value={
                            //         (() => {
                            //             if (doctorListingApiResponse) {
                            //                 if (field.value === "") return null;
                                            
                            //                 const options = filteredDocListing.map((item) => ({
                            //                     value: item.id.toString(),
                            //                     label: item.name,
                            //                 }));
                            //                 const selected = options.find((opt) => opt.value === field.value) as unknown as MultiValue<unknown>;
                            //                 if (selected) {
                            //                     return selected;
                            //                 }
                            //             }
                            //         })()
                            //     }
                            //     onChange={(selected) => {
                            //         const value = (selected as { value: string; label: string } | null)?.value || "";
                            //         // update RHF value
                            //         field.onChange(value);
                            //         // 👇 apna function call karo
                            //        // handlePracticeChange(value);
                            //     }}
                            noOptionsMessage={() => "Please enter 2 or more characters to search..."}
                            onInputChange={debouncedFilterDoctor}
                            onMenuClose={() => updatedFilteredDocListing([])}
                        />
                    )}
                />
            </div>
            <div className=" col mb-2">
                 <Controller
                    name="insurance_name"
                    control={control}
                    defaultValue=""
                    render={({ field }) => {
                        // local state to keep track of user typing
                        const handleInputChange = (inputValue: string, actionMeta: any) => {
                            if (actionMeta.action === "input-change") {
                                debouncedFilterInsurance(inputValue);
                                // store the last input in case no result found
                                field.onChange({ value: inputValue, label: inputValue });
                            }
                        };

                        return (
                            <Select
                                {...field}
                                id="insurance_name"
                                placeholder="Select Insurance"
                                isSearchable
                                isClearable
                                options={(filteredInsuranceListing.length > 0 ?
                                filteredInsuranceListing.map((item) => ({ value: item.id, label: item.name }))
                                : []
                            ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                                onInputChange={handleInputChange}
                                onMenuClose={() => updatedFilteredInsuranceListing([])}
                                noOptionsMessage={({ inputValue }) => {
                                    if (!inputValue) return "Please enter 2 or more characters to search...";
                                    if (inputValue.length < 2)
                                        return "Please enter 2 or more characters to search...";
                                    return `No results found for "${inputValue}"`;
                                }}
                            />
                        );
                    }}
                 />
             </div> 
            <div className="col btn-col mb-2">
                <div className="row g-2">
                    <div className="col-6">
                        <button type="submit" className="btn btn-primary w-100">Search</button>
                    </div>
                    <div className="col-6">
                        <button type="button" onClick={clearFormData} className="btn btn-outline-secondary w-100">Clear</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

 export default ReportsFilter;

// import { FC, useContext, useEffect, useState } from "react";
// import { GroupBase, MultiValue, OptionsOrGroups } from "react-select";
// import { useForm, Controller } from "react-hook-form";
// import Select from "react-select";
// import { format, parse, } from "date-fns";
// import DatePicker from "react-datepicker";
// import ReactInputMask from "react-input-mask";
// import { useDebouncedCallback } from "use-debounce";


// import { reportFilterProps, ReportFilterState } from "./types";
// import { DRUG_NAME } from "src/components/ActionDashBoardFilter/types";
// import { AuthContext } from "src/context/authContext";
// import { isZilrettaUser } from "src/helpers";
// import { limitShift, offset, shift } from "@floating-ui/react";
// import useFetch from "src/hooks/useFetch";
// import { APIEndpoints } from "src/types/apiTypes";




// const ReportsFilter: FC<reportFilterProps> = ({ updateQueryParams, defaultQueryParams }): JSX.Element => {

//     const [filteredDocListing, updatedFilteredDocListing] = useState<{ id: number; name: string; }[]>([])
//     const [filteredPracticeListing, updatedFilteredPracticeListing] = useState<{ id: number; name: string; }[]>([])
//     const [filteredInsuranceListing, updatedFilteredInsuranceListing] = useState<{ id: number; name: string; }[]>([])


//     const { control, handleSubmit, reset, getValues, watch, setValue } = useForm<ReportFilterState>({
//         mode: 'all',
//         defaultValues: defaultQueryParams,
//     });
//     const { userData } = useContext(AuthContext);
//     setValue("drug_name", getValues('drug_name') === "All Product" || getValues('drug_name') === "" ? DRUG_NAME[0].value : getValues('drug_name'))
//     const start_date = watch("start_date");
//     const end_date = watch("end_date");
//     const practice_Id = watch("practice_id");

//     const { error: insuranceListingApiError, data: insuranceListingApiResponse, mutate: getinsuranceListing } =
//         useFetch<{ id: number; name: string; }[]>(APIEndpoints.FETCH_INSURANCE);

//     /** @first */
//     useEffect(() => {
//         if (insuranceListingApiResponse || insuranceListingApiError) {
//           if (insuranceListingApiResponse) {
//             updatedFilteredInsuranceListing((oldVal) => {
//               const merged = [...oldVal, ...insuranceListingApiResponse];
//               const uniqueSorted = Array.from(new Map(merged.map(i => [i.id, i])).values())
//                 .sort((a, b) => (a.name > b.name ? 1 : -1));
//               return uniqueSorted;
//             });
//           }
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//       }, [insuranceListingApiResponse, insuranceListingApiError]);     


//     const { error: doctorListingApiError, data: doctorListingApiResponse, mutate: getdoctorListing } =
//         useFetch<{ id: number; name: string; }[]>(APIEndpoints.GET_MANUFACTURER_FILTER_DOCTOR);



//     /** @second */
//     useEffect(() => {
//         if (doctorListingApiResponse && !doctorListingApiError) {
//           updatedFilteredDocListing((prev) => {
//             const combined = [...prev, ...doctorListingApiResponse];
//             // Deduplicate by ID
//             const unique = Array.from(new Map(combined.map((doc) => [doc.id, doc])).values());
//             // Sort alphabetically
//             return unique.sort((a, b) => a.name.localeCompare(b.name));
//           });
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//       }, [doctorListingApiResponse]);
      



//     const { error: practiceListingApiError, data: practiceListingApiResponse, mutate: getpracticeListing } =
//         useFetch<{ id: number; name: string; }[]>(APIEndpoints.GET_MANUFACTURER_FILTER_PRACTICE);



//     /** @third */
//     useEffect(() => {
//         if (practiceListingApiResponse || practiceListingApiError) {
//             if (practiceListingApiResponse) {
//                 updatedFilteredPracticeListing((oldVal) => {
//                     const newPatients = [...oldVal, ...practiceListingApiResponse]
//                         .sort((patientA, patientB) => (patientA.name > patientB.name) ? 1 : -1)
//                     return [...new Map(newPatients.map(patient => [patient["id"], patient])).values()];
//                 })
//             }
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [practiceListingApiResponse, practiceListingApiError]);




//     const searchForStats = (values: ReportFilterState) => {
//         const updatedValues = {
//             ...defaultQueryParams,
//             ...values,
//             practice_id:
//                 values.practice_id ?
//                     (typeof values.practice_id === "string" ? values.practice_id : (values.practice_id as unknown as { value: string; label: string; }).value)
//                     : "",
//             drug_name:
//                 values.drug_name
//                     ? (typeof values.drug_name === "string"
//                         ? values.drug_name === "All Product"
//                             ? ""
//                             : values.drug_name
//                         : (values.drug_name as { value: string; label: string }).value === "All Product"
//                             ? ""
//                             : (values.drug_name as { value: string; label: string }).value)
//                     : "",
//                     global_doctor_ids: Array.isArray(values.global_doctor_ids)
//                     ? values.global_doctor_ids.join(",")
//                     : typeof (values.global_doctor_ids as any)?.value !== "undefined"
//                     ? Array.isArray((values.global_doctor_ids as any).value)
//                       ? (values.global_doctor_ids as any).value.join(",")
//                       : String((values.global_doctor_ids as any).value)
//                     : "",
//             insurance_name:
//                 values.insurance_name ?
//                     (typeof values.insurance_name === "string" ? values.insurance_name : (values.insurance_name as unknown as { value: string; label: string; }).label)
//                     : "",
//         };

//         updateQueryParams(updatedValues, false);
//     };






//     //:- Filtering practice from api recieved listing
//     const filterPractice = (search: string) => {
//         if (search.length >= 2) {
//             getpracticeListing({}, {}, { query: search.trim() })
//             // updatedFilteredPracticeListing(
//             //     practiceDropdown.filter((prac) => prac.name.toLowerCase().includes(search.toLowerCase()))
//             // )
//         }
//     };
//     const debouncedFilterPractice = useDebouncedCallback(filterPractice, 500);

//     //:- Filtereing doctor from api recieved listing
//     const filterDoctor = (search: string) => {
//         if (search.length >= 2) {
//             !practice_Id && getdoctorListing({}, {}, { query: search.trim() })
//         }

//     };
//     const debouncedFilterDoctor = useDebouncedCallback(filterDoctor, 500);

//     const filterInsurance = (search: string) => {
//         if (search.length >= 2) {
//             !practice_Id && getinsuranceListing({}, {}, { insurance_name: search.trim() })
//         }

//     };
//     const debouncedFilterInsurance = useDebouncedCallback(filterInsurance, 500);



//     const handlePracticeChange = (practiceId: string) => {
//         practiceId && getdoctorListing({}, {},
//             { practice_id: practiceId }
//         )
//     };
//     const clearFormData = () => {
//         const values = {
//             ...defaultQueryParams,
//             start_date: format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
//             end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
//             practice_id: "",
//             global_doctor_id: "",
//             //case_id: "",
//             //global_patient_id: "",
//             //patient_id: "",
//             // doctor_name: "",
//             drug_name: "",
//             insurance_name: ""
//             //global_patient_external_id:''


//         };

//         reset(values);
//         updatedFilteredDocListing([]);
//         console.log("FILTER LISTINGG", filteredDocListing)
//         updatedFilteredPracticeListing([]);
//         updateQueryParams(getValues(), true);
//     };

//     return (
//         <form className="filters row g-2" onSubmit={handleSubmit(searchForStats)}>
//             <div className="col product-field mb-2">
//                 <Controller
//                     name="drug_name"
//                     control={control}
//                     defaultValue={DRUG_NAME[0]?.value} // pehla option default
//                     render={({ field }) => {
//                         //console.log("drug_name field.value 👉", field.value);
//                         return (
//                             <Select
//                                 id="drug_name"
//                                 placeholder="Select Product"
//                                 isDisabled={isZilrettaUser(userData)}
//                                 options={
//                                     DRUG_NAME.length > 0
//                                         ? DRUG_NAME.map((item) => ({
//                                             value: item.value,
//                                             label: item.label,
//                                         }))
//                                         : []
//                                 }
//                                 value={
//                                     field.value
//                                         ? DRUG_NAME.find((item) => item.value === field.value)
//                                         : null
//                                 }
//                                 onChange={(selectedOption) =>
//                                     field.onChange(selectedOption ? selectedOption.value : "")
//                                 }
//                                 onBlur={field.onBlur}
//                             />
//                         );
//                     }}
//                 />


//             </div>
//             <div className="col date-field mb-2">
//                 <Controller
//                     name="start_date"
//                     control={control}
//                     defaultValue=""
//                     render={({ field }) => (
//                         <DatePicker
//                             selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
//                             onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
//                             customInput={
//                                 <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
//                                     <input {...inputProps} />}
//                                 </ReactInputMask>
//                             }
//                             className="form-control" wrapperClassName="w-100"
//                             placeholderText="mm/dd/yyyy"
//                             dateFormat="MM/dd/yyyy"
//                             showMonthDropdown
//                             showYearDropdown
//                             maxDate={end_date ? new Date(end_date) : undefined}
//                             portalId="root"
//                             popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
//                         />
//                     )}
//                 />
//             </div>
//             <div className="col date-field mb-2">
//                 <Controller
//                     name="end_date"
//                     control={control}
//                     defaultValue=""
//                     render={({ field }) => (
//                         <DatePicker
//                             selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
//                             onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
//                             customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) => <input {...inputProps} />}</ReactInputMask>}
//                             className="form-control" wrapperClassName="w-100"
//                             placeholderText="mm/dd/yyyy"
//                             dateFormat="MM/dd/yyyy"
//                             showMonthDropdown
//                             showYearDropdown
//                             minDate={start_date ? new Date(start_date) : undefined}
//                             portalId="root"
//                             popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
//                         />
//                     )}
//                 />
//             </div>
//             <div className="col mb-2">
//                 <Controller
//                     name="practice_id"
//                     control={control}
//                     render={({ field }) => {
//                         return (
//                             <Select
//                                 options={(filteredPracticeListing.length > 0 ?
//                                     filteredPracticeListing.map((item) => ({
//                                         value: item.id.toString(),
//                                         label: item.name
//                                     }))
//                                     : []
//                                 ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
//                                 id="practice_id"
//                                 placeholder="Select Practice"
//                                 isSearchable={true}
//                                 isClearable={true}
//                                 {...field}
//                                 value={
//                                     (() => {
//                                         if (practiceListingApiResponse) {
//                                             if (field.value === "") return null;
//                                             const options = filteredPracticeListing.map((item) => ({
//                                                 value: item.id.toString(),
//                                                 label: item.name,
//                                             }));
//                                             const selected = options.find((opt) => opt.value === field.value) as unknown as MultiValue<unknown>;
//                                             if (selected) {
//                                                 return selected;
//                                             }
//                                         }
//                                     })()
//                                 }
//                                 onChange={(selected) => {
//                                     const value = (selected as { value: string; label: string } | null)?.value || "";
//                                     // update RHF value
//                                     field.onChange(value);
//                                     // 👇 apna function call karo
//                                     handlePracticeChange(value);
//                                 }}
//                                 noOptionsMessage={() => "Please enter 2 or more characters to search..."}
//                                 onInputChange={debouncedFilterPractice}
//                                 onMenuClose={() => updatedFilteredPracticeListing([])}

//                             />
//                         )
//                     }}
//                 />
//             </div>
//             <div className="col mb-2">
//                 <Controller
//                     name="global_doctor_ids"
//                     control={control}
//                     defaultValue={''}
//                     render={({ field }) => (
//                         <Select
//                             options={(filteredDocListing.length > 0 ?
//                                 filteredDocListing.map((item) => ({ value: item.id, label: item.name }))
//                                 : []
//                             ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
//                             id="global_doctor_ids"
//                             placeholder="Select Doctor"
//                             isSearchable={true}
//                             isClearable={true}
//                             {...field}
//                             noOptionsMessage={() => "Please enter 2 or more characters to search..."}
//                             onInputChange={debouncedFilterDoctor}
//                             onMenuClose={() => updatedFilteredDocListing([])}
//                         />
//                     )}
//                 />
//             </div>
//             <div className=" col mb-2">
//                 <Controller
//                     name="insurance_name"
//                     control={control}
//                     defaultValue=""
//                     render={({ field }) => {
//                         // local state to keep track of user typing
//                         const handleInputChange = (inputValue: string, actionMeta: any) => {
//                             if (actionMeta.action === "input-change") {
//                                 debouncedFilterInsurance(inputValue);
//                                 // store the last input in case no result found
//                                 field.onChange({ value: inputValue, label: inputValue });
//                             }
//                         };

//                         return (
//                             <Select
//                                 {...field}
//                                 id="insurance_name"
//                                 placeholder="Select Insurance"
//                                 isSearchable
//                                 isClearable
//                                 options={(filteredInsuranceListing.length > 0 ?
//                                 filteredInsuranceListing.map((item) => ({ value: item.id, label: item.name }))
//                                 : []
//                             ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
//                                 onInputChange={handleInputChange}
//                                 onMenuClose={() => updatedFilteredInsuranceListing([])}
//                                 noOptionsMessage={({ inputValue }) => {
//                                     if (!inputValue) return "Please enter 2 or more characters to search...";
//                                     if (inputValue.length < 2)
//                                         return "Please enter 2 or more characters to search...";
//                                     return `No results found for "${inputValue}"`;
//                                 }}
//                             />
//                         );
//                     }}
//                 />
//             </div>
//             <div className="col btn-col mb-2">
//                 <div className="row g-2">
//                     <div className="col-6">
//                         <button type="submit" className="btn btn-primary w-100">Filter</button>
//                     </div>
//                     <div className="col-6">
//                         <button type="button" onClick={clearFormData} className="btn btn-outline-secondary w-100">Clear</button>
//                     </div>
//                 </div>
//             </div>
//         </form>
//     );
// };

// export default ReportsFilter;
